// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BxaZ5","textarea":"styles_textarea__13PTD"};